export default "__VITE_ASSET__DlXqK5NL__"